<template lang="pug">
include SchoolAdminLogout.pug
</template>

<script>

export default {
  name: 'SchoolAdminLogout',
  mounted() {
    localStorage.removeItem(window.PREFIX + "token")
    localStorage.removeItem(window.PREFIX + "type")
    this.$store.commit("set_token", null);
    this.$store.commit("set_type", null);
    this.$router.push({
      name: "Root",
    });
  }
}

</script>

<style scoped lang="scss">
@importy "SchoolAdminLogout";
</style>



// WEBPACK FOOTER //
// src/components/school_admin_logout/SchoolAdminLogout.vue